import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {
  initialiseSegment,
  OneTrustConsent,
  GTMContainer,
} from '@crunchyroll/cr-static-shared-components'

import favicon from '@images/favicon.png'
import { languageList } from '@intl'
import Metadata from '@components/seo/metadata'
import { useSiteMetadata } from '@hooks/use-site-metadata'

const PageComponent = ({ pathname = '', element }) => {
  const {
    assetPrefix,
    siteMetadata: { baseUrl: url },
  } = useSiteMetadata()

  const path = pathname.replace(assetPrefix, '')
  let canonicalHref = `${url}${pathname}`

  const langList = !Array.isArray(languageList)
    ? Object.keys(languageList)
    : languageList
  const localized = langList.find((lang) => path.includes(`/${lang}/`))
  const isDefaultPage = localized ? false : true
  if (isDefaultPage) canonicalHref = `${url}${assetPrefix}${path}`

  return (
    <>
      <OneTrustConsent />

      {typeof window !== 'undefined' && initialiseSegment(false)}

      <Helmet>
        <link rel="icon" href={favicon} />
        <link rel="canonical" href={canonicalHref} />
        <link rel="preconnect" href="https://api.storyblok.com" />
        <meta property="og:url" content={canonicalHref} />
      </Helmet>
      <GTMContainer />
      {isDefaultPage && <Metadata />}
      {element}
    </>
  )
}

PageComponent.propTypes = {
  pathname: PropTypes.string,
  element: PropTypes.node.isRequired,
}

export default PageComponent
